'use client';

import { createContext, useMemo } from 'react';

import { Box } from '@mui/material';
import SearchMain from '@/components/SearchMain';
import { Vendor } from '@/lib/types/interfaces/Vendor';
import { DTOServices } from '@/lib/types/interfaces/DTO';
import { colorVariables } from '@/constants';
import { Linking } from '@/lib/types/interfaces/Linking';
import SearchResults from './SearchResults';
import ServicesList from '@/components/ServicesList';
import QuestionsAnswers from '@/components/QuestionsAnswers';
import theme from '@/theme';
import { Question } from '@/lib/types/interfaces/Question';

interface Props {
  seoCategories?: Linking[];
  searchData?: DTOServices<Vendor[]>;
  questions?: Question[];
}

interface Context extends Omit<Props, 'searchData'> {
  searchData?: Vendor[],
  searchTotal: number;
  searchMeta: {
    title: string;
    description: string;
  };
}

export const ServiceContext = createContext<Context>({
  seoCategories: [],
  searchTotal: 0,
  searchMeta: {
    title: '',
    description: '',
  },
});

const Services = ({
  seoCategories, searchData, questions,
}: Props) => (
  <ServiceContext.Provider value={useMemo(() => ({
    seoCategories,
    searchData: searchData?.data || [],
    searchTotal: searchData?.count || 0,
    searchMeta: searchData!?.meta,
  }), [searchData])}
  >
    <SearchMain>
      <SearchResults />
      {questions?.length && (
        <Box
          mt={{ xs: 2, md: 3 }}
          mb={6}
          sx={{
            paddingX: 3,
            [theme.breakpoints.up('lg')]: {
              paddingX: 18,
              marginTop: 6,
            },
          }}
        >
          <QuestionsAnswers questions={questions!} />
        </Box>
      )}
    </SearchMain>
    {!!seoCategories?.length && (
      <Box
        paddingY={4}
        paddingX={3}
        borderTop={`1px solid ${colorVariables.separatorColor}`}
      >
        <ServicesList
          seoCategories={seoCategories || []}
          title='More Service Providers You May Be Interested In'
        />
      </Box>
    )}
  </ServiceContext.Provider>
);
export default Services;
